import React, { Component } from 'react'
import Cropper from 'react-easy-crop'
import { Button, Image, Modal, Col, Row, Badge } from 'react-bootstrap'
import getCroppedImg from './cropImage'
import './styles.css'
import axios from 'axios';
import Loader from '../../component/Loader/Loader';
import { withRouter } from 'react-router-dom';
import ErrorModal from '../../component/ErrorModal/ErrorModal';
import { msalInstance } from "../../msalConfig";
import Resizer from 'react-image-file-resizer';
import RangeSlider from 'react-bootstrap-range-slider';
import Upload from '../Upload/Upload'

const resizeFile = (file, width, height) => new Promise(resolve => {
  Resizer.imageFileResizer(file, width, height, 'JPEG', 100, 0,
    uri => {
      resolve(uri);
    }, 'base64', width, height);
});

class ImageCrop extends Component {
  state = {
    crop: {
      x: 0,
      y: 0
    },
    setCrop: {
      x: 0,
      y: 0
    },
    zoom: 1,
    croppedAreaPixels: null,
    croppedImage: null,
    setCroppedImage: null,
    maxZoom: 2,
    accesstoken: this.props.accesstoken,
    cropSize: {
      width: 480,
      height: 640
    },
    show: false,
    value: 1
  }

  cropImageParent = React.createRef(null);

  addOutline = () => {
    if(this.cropImageParent && this.cropImageParent.current){
      let node = this.cropImageParent.current.querySelector(".reactEasyCrop_CropArea");
      if(node) {
        node.classList.add("outline");
      }
    }
  }

  componentDidMount(){
    setTimeout(this.addOutline,1000);
  }

  showCroppedImage = async () => {
    try {
      let image = this.props.image
      if (this.state.imageUrl) {
        image = this.state.imageUrl
      }
      const croppedImage = await getCroppedImg(
        image,
        this.state.setCroppedAreaPixels,
        this.state.rotation
      )

      //To detect browser type
      const isIE = /*@cc_on!@*/false || !!document.documentMode;
      
      let file

      if (isIE) {
        //File constructor does not exist in IE and hence using blob with last modified date and name
        file = await fetch(croppedImage).then(r => r.blob());
        file.lastModifiedDate = new Date();
        file.name = this.props.studentID + '.jpeg';
      } else {
        //File constructor works in other browser
        file = await fetch(croppedImage).then(r => r.blob()).then(blobFile => new File([blobFile], this.props.studentID + '.jpeg', { type: "image/jpeg" }))
        /*
        file = await fetch(croppedImage).then(r => r.blob());
        file.lastModifiedDate = new Date();
        file.name = this.props.studentID + '.jpeg';
        */
      }

      this.setState({
        setCroppedImage: croppedImage,
        setCroppedImageFile: file
      })

    } catch (e) {
      console.error(e)
    }
  }

  onCropChange = crop => {
    this.setState({ crop })
  }

  onCropComplete = (croppedArea, croppedAreaPixels) => {
    this.setState({ setCroppedAreaPixels: croppedAreaPixels })
  }

  onZoomChange = zoom => {
    this.setState({ zoom })
  }

  cropHandler = async () => {
    await this.showCroppedImage()
    const file = this.state.setCroppedImageFile

    this.setState({ showImage: true, showError: false })

    // if (file.size > 150000) {
    //   this.setState({
    //     disableCrop: true,
    //     disableUpload: true,
    //     showImage: false,
    //     showError: true,
    //     errorMsg: 'Please crop a passport size photo with size less than 150kb'
    //   })
    // } 
  }

  disableHandler = async ({ target: img }) => {
    const height = img.naturalHeight
    const width = img.naturalWidth

    console.log('disableHandler', width, height)

    if (height <640 || width <480) {
      const imageURL = await resizeFile(this.state.setCroppedImageFile, 480, 640);

      const isIE = /*@cc_on!@*/false || !!document.documentMode;

      let file

      if (isIE) {
        //File constructor does not exist in IE and hence using blob with last modified date and name
        file = await fetch(imageURL).then(r => r.blob());
        file.lastModifiedDate = new Date();
        file.name = this.props.studentID + '.jpeg';
      } else {
        //File constructor works in other browser
        file = await fetch(imageURL).then(r => r.blob()).then(blobFile => new File([blobFile], this.props.studentID + '.jpeg', { type: "image/jpeg" }))
      }
      console.log('disableHandler', file.size)

      // if (file.size > 500000) {
      //   this.setState({
      //     disableCrop: true,
      //     disableUpload: true,
      //     showImage: false,
      //     showError: true,
      //     errorMsg: 'Please crop a passport size photo with size less than 500kb'
      //   })
      //   return
      // }

      this.setState({
        setCroppedImage: imageURL,
        setCroppedImageFile: file
      })
    }

    // if (height < 640 || width < 480) {
    //   this.setState({
    //     disableCrop: true,
    //     disableUpload: true,
    //     showImage: false,
    //     showError: true,
    //     errorMsg: 'Please crop a passport size photo with resolution 480x640 or bigger'
    //   })
    //   return
    // }
  }

  closeHandler = () => {
    this.setState({ showImage: false, showError: false })
  }

  uploadHandler = async (event) => {
    this.setState({ isLoading: true })
    event.preventDefault();

    // const isIE = /*@cc_on!@*/false || !!document.documentMode;

    // let file

    // if (isIE) {
    //   //File constructor does not exist in IE and hence using blob with last modified date and name
    //   file = await fetch(this.state.setCroppedImage).then(r => r.blob());
    //   file.lastModifiedDate = new Date();
    //   file.name = this.props.studentID + '.jpeg';
    // } else {
    //   //File constructor works in other browser
    //   file = await fetch(this.state.setCroppedImage).then(r => r.blob()).then(blobFile => new File([blobFile], this.props.studentID + '.jpeg', { type: "image/jpeg" }))
    // }

    const url = process.env.REACT_APP_VALIDATEIMAGE

    console.log(this.state.setCroppedImageFile)
    
    console.log("Img size After Resizing : ", this.state.setCroppedImageFile.size);

    if (this.state.setCroppedImageFile.size < 60000){
        console.log("File size cropped to less than 60kb");
        this.setState({
          errorMsg: 'Photo size has reduced below 60kb after cropping, Please re-upload a photo with size more than 60kb',
          showError: true,
          isLoading: false
        })
        return
    }

    console.log("Size validation completed");

    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data'
    };
    if (this.state.accesstoken) {
      headers["Authorization"] = `Bearer ${this.state.accesstoken}`;
    }

    //Retrieve image base64 string
    //var imageBuffer = this.state.setCroppedImage.split(',');

    const fileExtension = this.props.imageName.split('.').pop();

    const form = new FormData();
    form.append('byteData', this.state.setCroppedImageFile)
    form.append('filename', this.props.studentID + '.' + fileExtension);
    form.append('userid', this.props.studentID);
    form.append('usertype', this.props.userType);
    form.append('loginUserType',this.props.location.state.userType);//20240301
    console.log('loginUserType1'+this.props.location.state.userType);

    for (var pair of form.entries()) {
      console.log(pair[0] + ', ' + pair[1]);
    }

    axios.post(url, form, {
      headers: headers
    }).then((response) => {
      const result = response.data;
      //console.log(result)
      if (result.uploadStatus || result.uploadRemarks) {
        this.setState({
          //showResult: true,
          isLoading: false
        })
        console.log(this.state.isLoading)
        this.props.history.push({
          pathname: '/Result',
          state: {
            uploadStatus: result.uploadStatus,
            uploadRemarks: result.uploadRemarks,
            studentID: this.props.studentID,
            staffName: this.props.staffName,
            userType: this.props.type,
            accesstoken: this.props.accesstoken,
            role: this.props.role
          }
        })
      } else {
        this.setState({
          showError: true,
          errorMsg: "No result available. Please try again or check with the adminstrators",
          isLoading: false
        })
      }

    }).catch((error) => {
      //console.log('imagecrop', error)
      //console.log(this.state.isLoading)
      const url = process.env.REACT_APP_LOGEXCEPTION
      let headers = {
        'Content-Type': 'multipart/form-data'
      };

      headers["Authorization"] = `Bearer ${this.state.accesstoken}`;

      console.log(headers)

      const form = new FormData();

      let loggedinUser = this.props.studentID

      if (this.props.loggedinUser) {
        loggedinUser = this.props.loggedinUser
      }
      form.append('loggedinuserid', loggedinUser)
      form.append('student_staff_id', this.props.studentID);
      form.append('webapimethodname', process.env.REACT_APP_VALIDATEIMAGE);
      form.append('loginUserType',this.props.location.state.userType);//20240301
      console.log('loginUserType1'+this.props.location.state.userType);

      if (error.response) {
        form.append('error', error.response.status + ' ' + error.response.statusText);
      } else {
        form.append('error', error.message);
      }

      for (var pair of form.entries()) {
        console.log(pair[0] + ', ' + pair[1]);
      }

      axios.post(url, form, { headers: headers }).then((response) => {
        if (error.response) {
          if (error.response.status === '401') {
            this.setState({
              errorMsg: 'Your Session has expired. Please login again.',
              showError: true,
              isLoading: false
            })
            localStorage.clear()
            msalInstance.logout()
          } else {
            this.setState({
              errorMsg: error.response.status + ' ' + error.response.statusText,
              showError: true,
              isLoading: false
            })
          }
        } else {
          this.setState({
            showError: true,
            errorMsg: error.message,
            isLoading: false
          })
        }
      }).catch((error1) => {
        if (error.response) {
          if (error.response.status === '401') {
            this.setState({
              errorMsg: 'Your Session has expired. Please login again.',
              showError: true,
              isLoading: false
            })
            localStorage.clear()
            msalInstance.logout()
          } else {
            this.setState({
              errorMsg: error.response.status + ' ' + error.response.statusText,
              showError: true,
              isLoading: false
            })
          }
        } else {
          this.setState({
            showError: true,
            errorMsg: error.message,
            isLoading: false
          })
        }
      });

      // this.props.history.push({
      //   pathname: '/Result',
      //   state: {
      //     uploadStatus: true,
      //     uploadRemarks: 'Success',
      //     studentID: this.props.studentID,
      //     userType: this.props.type,
      //     accesstoken: this.props.accesstoken
      //   }
      // })

    });
  }

  sliderHandler = (e) => {
    this.setState({
      zoom: e.target.value
    })
  }

  cancelHandler = () => {
    this.setState({ returnToUpload: true })

  }

  render() {
    if (this.state.returnToUpload) {
      return <Upload
        staffName={this.props.staffName ? this.props.staffName : ''}
        studentID={this.props.studentID ? this.props.studentID : ''}
        role={this.props.userType ? this.props.userType : ''}
      />
    }


    let image = this.props.image
    if (this.state.imageUrl) {
      image = this.state.imageUrl
    }
    let cropper =
      <Cropper
        image={image}
        crop={this.state.crop}
        zoom={this.state.zoom}
        minZoom={1}
        maxZoom={3}
        zoomWithScroll={false}
        onCropChange={this.onCropChange}
        onCropComplete={this.onCropComplete}
        onZoomChange={this.onZoomChange}
        onMediaLoaded={mediaSize => {
          this.addOutline();
          // Adapt zoom based on media size to fit max height
          const cropHeight = mediaSize.height * (640 / mediaSize.naturalHeight)
          const cropWidth = mediaSize.width * (480 / mediaSize.naturalWidth)
          console.log()
          const size = {
            width: cropWidth,
            height: cropHeight
          }
          this.setState({ cropSize: size })
          //If size smaller than 480 x 640. No cropping
        }}
        cropSize={this.state.cropSize}
      />

    let crop =
      <div>
        <div className="crop-container" ref={this.cropImageParent}>
          {cropper}
        </div>
        <div className="controls col-md-8 offset-md-2">
          <Row>
            <Col>
              <Button className="mr" variant="success" size="md" onClick={(e) => this.cropHandler(e)}>
                Crop Image
          </Button>
            </Col>
            <Col>
              <Row>
                <Col className="my-auto" sm="2">
                  <Badge variant="success">Zoom</Badge>
                </Col>
                <Col sm="10">
                  <RangeSlider
                    value={this.state.zoom}
                    min={1}
                    max={3}
                    step={0.1}
                    onChange={e => this.sliderHandler(e)}
                    variant='success'
                    tooltip='off'
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              {/* <Button variant="success" size="md" onClick={() => window.location.reload()}>
                Cancel
              </Button> */}
              <Button variant="success" size="md" onClick={() => this.cancelHandler()}>
                Cancel
              </Button>
            </Col>
          </Row>
        </div>
      </div>

    let modal;
    if (this.state.showImage) {
      modal =
        <Modal show={this.state.showImage} onHide={() => this.closeHandler()}>
          <Modal.Header className="bg-brandcolor" closeButton>
            <h5 className="text-white">Cropped Image</h5>
          </Modal.Header>
          <Modal.Body className="text-center">
            {/* {this.state.imageUrl ? <Image src={this.state.setCroppedImage} thumbnail onLoad={this.disableHandler.bind(this)} /> : <Image src={this.state.setCroppedImage} thumbnail onLoad={this.disableHandler.bind(this)}/>} */}
            <Image src={this.state.setCroppedImage} thumbnail onLoad={this.disableHandler.bind(this)} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.closeHandler()}>
              Close
            </Button>
            <Button variant="success" onClick={(event) => this.uploadHandler(event)}>
              Upload
            </Button>
          </Modal.Footer>
        </Modal>
    }

    if (this.state.showError) {
      modal =
        <ErrorModal msg={this.state.errorMsg} show={this.state.showError} click={() => this.closeHandler()} />
    }

    return (
      <div>
        {this.state.isLoading ? <Loader isLoading={this.state.isLoading} /> : null}
        {crop}
        {modal}
      </div>
    )
  }
}

export default withRouter(ImageCrop)